export { default } from './MapHeader';
